import { gql } from "@apollo/client";

// Shared by CREATE_CLASSROOM_ACTIVITY/UPDATE_CLASSROOM_ACTIVITY so their return shape has one definition.
const CLASSROOM_ACTIVITY_AUDIT_FIELDS = gql`
  fragment ClassroomActivityAuditFields on ClassroomActivity {
    uid
    createdBy
    organizationUid
    name
    day
  }
`;

const CREATE_CLASSROOM_ACTIVITY = gql`mutation CreateClassroomActivity(
  $day: Day!, 
  $name: String!, 
  $startTime: Time!, 
  $endTime: Time!,
  $organizerUid: UUID,
  $placeUid: UUID,
  $classroomUid: UUID!,
  $periodUid: UUID!) {
createClassroomActivity(
input: {
    classroomActivity: {
    startTime: $startTime,
    endTime: $endTime,
    name: $name,
    placeUid: $placeUid,
    classroomUid: $classroomUid,
    periodUid: $periodUid,
    organizerUid: $organizerUid,
    day: $day}}
) {
classroomActivity {
    ...ClassroomActivityAuditFields
}
}
}
${CLASSROOM_ACTIVITY_AUDIT_FIELDS}`;

const UPDATE_CLASSROOM_ACTIVITY = gql`mutation UpdateClassroomActivity(
    $classroomActivityUid: UUID!,
    $day: Day!,
    $name: String!,
    $startTime: Time!,
    $endTime: Time!,
    $organizerUid: UUID,
    $placeUid: UUID,
    $classroomUid: UUID!,
    $periodUid: UUID!) {
    updateClassroomActivityByUid(input: {
      classroomActivityPatch: {
        startTime: $startTime,
        endTime: $endTime,
        name: $name,
        placeUid: $placeUid,
        periodUid: $periodUid,
        organizerUid: $organizerUid,
        classroomUid: $classroomUid,
        day: $day
      }, uid: $classroomActivityUid
    }) {
      classroomActivity {
        ...ClassroomActivityAuditFields
      }
    }
  }
  ${CLASSROOM_ACTIVITY_AUDIT_FIELDS}`;

const LIST_CLASSROOM_ACTIVITIES = gql`
query GetClassroomActivities($first: Int = 100, $offset: Int = 0, $filter: ClassroomActivityFilter!) {
  allClassroomActivities(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [DAY_ASC, START_TIME_ASC, NAME_ASC]) {
    nodes {
      uid
      name
      day
      startTime
      placeUid
      endTime
      classroomByClassroomUid {
        uid
        name
        usersByClassroomUid{
          totalCount
        }
      }
      userByOrganizerUid {
        uid
        firstName
        lastName
      }
      periodByPeriodUid {
        uid
        name
      }
    }
    totalCount
  }
} `;

const LIST_CLASSROOM_ACTIVITY_USERS = gql`
query ListClassroomActivityUsers($classroomActivityUid: UUID!) {
  allClassroomActivityUsers(condition: {classroomActivityUid: $classroomActivityUid}) {
    nodes {
      userByUserUid {
        classroomByClassroomUid {
          name
          uid
        }
        lastName
        firstName
        uid
      }
    }
  }
}
`;

const CREATE_CLASSROOM_ACTIVITY_USER = gql`mutation CreateClassroomActivityUser($classroomActivityUid: UUID!, $userUid: UUID!){
  createClassroomActivityUser(
    input: {classroomActivityUser: {classroomActivityUid: $classroomActivityUid, userUid: $userUid}}) {
    clientMutationId
  }
}
`;

const DELETE_CLASSROOM_ACTIVITY = gql`mutation DeleteClassroomActivity($classroomActivityUid: UUID!) {
  deleteClassroomActivityByUid(input: {uid: $classroomActivityUid}) {
    clientMutationId
  }
}
`;

const DELETE_CLASSROOM_ACTIVITY_USER = gql`mutation DeleteClassroomActivityUser($classroomActivityUid: UUID!, $userUid: UUID!) {
    deleteClassroomActivityUserByClassroomActivityUidAndUserUid(
      input: {classroomActivityUid: $classroomActivityUid, userUid: $userUid}
    ) { clientMutationId }
  }
`;

const COPY_ALL_CLASSROOM_ACTIVITIES = gql`mutation CopyAllClassroomActivities($sourcePeriodUid: UUID!, $targetPeriodUid: UUID!) {
  copyAllClassroomActivities(
    input: {sourcePeriodUid: $sourcePeriodUid, targetPeriodUid: $targetPeriodUid}
  ) {
    integer
  }
}
`;

const GET_ALL_APPOINTMENT_FOR_CLASSROOM = gql`
mutation GetAllAppointementForClassroom($classroomUid: UUID!, $periodUid: UUID!) {
  getAllAppointementForClassroom(
    input: { cUid: $classroomUid, pUid: $periodUid }
  ) {
    appointments {
      endDate
      itemUid
      startDate
      title
      type
      place
      organizer
    }
  }
} `;

export {
  CREATE_CLASSROOM_ACTIVITY,
  UPDATE_CLASSROOM_ACTIVITY,
  LIST_CLASSROOM_ACTIVITIES,
  LIST_CLASSROOM_ACTIVITY_USERS,
  CREATE_CLASSROOM_ACTIVITY_USER,
  DELETE_CLASSROOM_ACTIVITY,
  DELETE_CLASSROOM_ACTIVITY_USER,
  COPY_ALL_CLASSROOM_ACTIVITIES,
  GET_ALL_APPOINTMENT_FOR_CLASSROOM,
};
